import { Icon, Paper, Typography } from '@shared/ui';
import { registerWidgetRenderer } from '../registry';
import type { TimelineWidgetProps, ToolLogEntity } from '../types';

export function ToolLogWidget({ entity }: TimelineWidgetProps<ToolLogEntity>) {
  const { toolCallId, text, level = 'info' } = entity.props;

  const configs = {
    info: {
      icon: 'info',
      color: 'text.info',
      bg: 'bg-blue-50',
    },
    warn: {
      icon: 'warning',
      color: 'text.warning',
      bg: 'bg-yellow-50',
    },
    error: {
      icon: 'error',
      color: 'text.error',
      bg: 'bg-red-50',
    },
  };

  const config = configs[level];

  return (
    <Paper
      variant="outlined"
      className={`p-2 w-full min-w-0 ${config.bg} mp-block artifact-content`}
      sx={{ borderLeft: '4px solid' }}
    >
      <div className="flex items-start gap-2 min-w-0">
        <Icon sx={{ fontSize: 18, color: config.color, flexShrink: 0 }}>{config.icon}</Icon>
        <div className="flex-1 min-w-0">
          <Typography variant="caption" color="text.secondary" className="block mb-0.5">
            Tool Log: {toolCallId}
          </Typography>
          <Typography variant="body2" className="font-mono text-sm break-words whitespace-pre-wrap">
            {text}
          </Typography>
        </div>
        <Typography variant="caption" color="text.secondary" className="flex-shrink-0">
          {new Date(entity.timestamp).toLocaleTimeString()}
        </Typography>
      </div>
    </Paper>
  );
}

// Register renderer + visibility
registerWidgetRenderer(
  'tool_log',
  ({ entity }) => <ToolLogWidget key={(entity as any).id} entity={entity as any} />,
  { visibility: { normal: false, debug: true } }
);
